/*** IMPORTS FROM imports-loader ***/
var global = window;

module.exports = require('./lib/axios');
